package com.gsb.vyapar.bhagya.presentation.navigation.view

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Icon
import androidx.compose.material.ScaffoldState
import org.jetbrains.compose.resources.painterResource
import com.gsb.vyapar.bhagya.theme.delete_icon
import com.gsb.vyapar.bhagya.theme.info
import com.gsb.vyapar.bhagya.theme.share
import com.gsb.vyapar.bhagya.theme.star
import com.gsb.vyapar.bhagya.theme.thumb_up
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.painter.BitmapPainter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import androidx.navigation.NavHostController
import com.gsb.vyapar.bhagya.domain.getEmail
import com.gsb.vyapar.bhagya.domain.getFirstName
import com.gsb.vyapar.bhagya.domain.getImage
import com.gsb.vyapar.bhagya.domain.getLastName
import com.gsb.vyapar.bhagya.domain.getMobile
import com.gsb.vyapar.bhagya.domain.getShare
import com.gsb.vyapar.bhagya.domain.getWebsite
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.auth.util.isUserAdmin
import com.gsb.vyapar.bhagya.presentation.auth.util.isUserLoggedIn
import com.gsb.vyapar.bhagya.presentation.auth.util.launchLoginMobile
import com.gsb.vyapar.bhagya.presentation.auth.util.launchVerifyEmail
import com.gsb.vyapar.bhagya.presentation.auth.util.loginPopup
import com.gsb.vyapar.bhagya.presentation.auth.util.logout
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImageRound
import com.gsb.vyapar.bhagya.presentation.common.image.PlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.SmoothImageRound
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBB
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBBS
import com.gsb.vyapar.bhagya.presentation.common.text.Text24SemiBold
import com.gsb.vyapar.bhagya.presentation.navigation.util.checkUserAfterLogin
import com.gsb.vyapar.bhagya.presentation.navigation.util.pushView
import com.gsb.vyapar.bhagya.presentation.navigation.util.showDeleteAccount
import com.gsb.vyapar.bhagya.presentation.navigation.util.showSignOutPopup
import com.gsb.vyapar.bhagya.share
import com.gsb.vyapar.bhagya.theme.*
import com.gsb.vyapar.bhagya.util.BLANK_PROFILE
import com.gsb.vyapar.bhagya.util.BuildConfig
import com.gsb.vyapar.bhagya.util.canShowRateUs
import com.gsb.vyapar.bhagya.util.getRateUsUrl
import com.gsb.vyapar.bhagya.util.getShare
import com.gsb.vyapar.bhagya.util.value
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource

@Composable
fun NavigationDrawerView(
    uiState: UiState,
    onTriggerEvent: (UiEvents) -> Unit,
    navController: NavHostController,
    scaffoldState: ScaffoldState,
    scope: CoroutineScope
) {
    val uriHandler = LocalUriHandler.current
    Column(
        modifier = Modifier
            .fillMaxHeight()
            .width(400.dp)
            .background(color = white)
            .verticalScroll(rememberScrollState()),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Spacer(Modifier.height(25.dp))
        CommonImage(painterResource(splash), Modifier.width(200.dp).height(200.dp))
        //uiState.getImage(LOGOIMG.value())?.let { imageBitmap -> CommonImage(imageBitmap, 200.dp, 200.dp) }?: PlaceHolder(200.dp, 200.dp)
        Spacer(Modifier.height(15.dp))
        Text24SemiBold("GSB-VyaparBhagya", black)
        Text14RegularBB("Version : ${BuildConfig.getVersion()}", black)
        Spacer(Modifier.height(15.dp))
        Column(
            modifier = Modifier.fillMaxWidth().padding(16.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            val user = uiState.getUser()
            if (!isUserLoggedIn()) {
                GVBButton(text = "Login") {
                    loginPopup()
                    scope.launch { scaffoldState.drawerState.close() }
                }
                Spacer(Modifier.height(15.dp))
                GVBButton(text = "Manage Business") {
                    loginPopup()
                    scope.launch { scaffoldState.drawerState.close() }
                }
                Spacer(Modifier.height(15.dp))
            } else {
                Row(
                    modifier = Modifier.wrapContentHeight().fillMaxWidth().background(offwhite).clickable {
                            checkUserAfterLogin()
                            scope.launch { scaffoldState.drawerState.close() }
                        }.padding(16.dp), verticalAlignment = Alignment.CenterVertically
                ) {
                    SmoothImageRound(
                        uiState.getImage(uiState.getUser().getImage().ifEmpty { BLANK_PROFILE.value() }),
                        width = 80.dp,
                        height = 80.dp
                    )
                    Spacer(Modifier.width(15.dp))
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        verticalArrangement = Arrangement.Center
                    ) {
                        Text14RegularBBS("${user.getFirstName()} ${user.getLastName()}", black)
                        Text14RegularBBS(user.getMobile(), black)
                        Text14RegularBBS(user.getEmail(), black)
                    }
                }
                Spacer(Modifier.height(15.dp))
                GVBButton(text = "Manage Business") {
                    scope.launch { scaffoldState.drawerState.close() }
                    if (user.getEmail().isEmpty()) {
                        launchVerifyEmail()
                    } else if (user.getFirstName().isEmpty()){
                        pushView(Screens.Register)
                    } else {
                        getBusinessUiState().updateLoadReviewBusiness(true)
                        getBusinessUiState().updateManageBusinessTab(0)
                        pushView(Screens.ManageBusiness)
                    }
                }
                if (isUserAdmin()) {
                    Spacer(Modifier.height(15.dp))
                    GVBButton(text = "Admin") {
                        scope.launch { scaffoldState.drawerState.close() }
                        pushView(Screens.AdminView)
                    }
                }
                Spacer(Modifier.height(15.dp))
                GVBButton(text = "Sign Out") {
                    showSignOutPopup()
                }
            }
            Spacer(Modifier.height(15.dp))
            Row(
                modifier = Modifier.height(40.dp).fillMaxWidth()
                    .clickable { uriHandler.openUri(uiState.getInfo().getWebsite()) },
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(
                    painter = painterResource(thumb_up),
                    contentDescription = "ThumbUp",
                    tint = black
                )
                Spacer(Modifier.width(8.dp))
                Text14RegularB("Support Us", black)
            }
            Spacer(Modifier.height(15.dp))
            Row(
                modifier = Modifier.height(40.dp).fillMaxWidth()
                    .clickable { share(getShare()) },
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(painter = painterResource(share), contentDescription = "Share", tint = black)
                Spacer(Modifier.width(8.dp))
                Text14RegularB("Share", black)
            }
            Spacer(Modifier.height(15.dp))
            if (canShowRateUs()) {
                Row(
                    modifier = Modifier.height(40.dp).fillMaxWidth()
                        .clickable { uriHandler.openUri(getRateUsUrl()) },
                    horizontalArrangement = Arrangement.Start,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(painter = painterResource(star), contentDescription = "Star", tint = black)
                    Spacer(Modifier.width(8.dp))
                    Text14RegularB("Rate Us", black)
                }
                Spacer(Modifier.height(15.dp))
            }
            Row(
                modifier = Modifier.height(40.dp).fillMaxWidth().clickable {
                    scope.launch { scaffoldState.drawerState.close() }
                    pushView(Screens.About)
                },
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(painter = painterResource(info), contentDescription = "About", tint = black)
                Spacer(Modifier.width(8.dp))
                Text14RegularB("About GSB-VyaparBhagya", black)
            }
            Spacer(Modifier.height(15.dp))
            if (isUserLoggedIn()) {
                Row(
                    modifier = Modifier.height(40.dp).fillMaxWidth()
                        .clickable { showDeleteAccount() },
                    horizontalArrangement = Arrangement.Start,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        painter = painterResource(delete_icon),
                        contentDescription = "Delete",
                        tint = black
                    )
                    Spacer(Modifier.width(8.dp))
                    Text14RegularB("Delete Account", black)
                }
                Spacer(Modifier.height(15.dp))
            }
        }
    }
}